import { render, staticRenderFns } from "./ElementTabs.vue?vue&type=template&id=4a4edfae&"
import script from "./ElementTabs.vue?vue&type=script&lang=js&"
export * from "./ElementTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports